import { Dictionary } from './dictionary';

export class EquipmentType extends Dictionary {
    OrderType: string;
    OrderTypeID: number;
    Region: string;
    RegionID: number;
}
